import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const iconButtonDefaultVariants = {
  "variant": "tertiary"
}
const iconButtonCompoundVariants = []

const iconButtonSlotNames = [
  [
    "root",
    "iconButton__root"
  ]
]
const iconButtonSlotFns = /* @__PURE__ */ iconButtonSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, iconButtonDefaultVariants, getSlotCompoundVariant(iconButtonCompoundVariants, slotName))])

const iconButtonFn = memo((props = {}) => {
  return Object.fromEntries(iconButtonSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const iconButtonVariantKeys = [
  "variant"
]
const getVariantProps = (variants) => ({ ...iconButtonDefaultVariants, ...compact(variants) })

export const iconButton = /* @__PURE__ */ Object.assign(iconButtonFn, {
  __recipe__: false,
  __name__: 'iconButton',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: iconButtonVariantKeys,
  variantMap: {
  "variant": [
    "impact",
    "primary",
    "secondary",
    "tertiary"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, iconButtonVariantKeys)
  },
  getVariantProps
})